import React, { useEffect } from 'react';
import styled from 'styled-components';
import ConfirmDeletion from '../components/ConfirmDeletion/ConfirmDeletion';

const PageContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 140px); /* Account for header height */
  
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    min-height: calc(100vh - 90px);
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    min-height: calc(100vh - 80px);
  }
`;

const ConfirmDeletionPage: React.FC = () => {
  useEffect(() => {
    document.title = 'Confirm Account Deletion - Radyofone';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', 'Confirm your Radyofone account deletion request.');
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', 'https://www.radyofone.com/confirm-deletion');
    // This is a flow page, set noindex
    const robots = document.querySelector('meta[name="robots"]');
    if (robots) robots.setAttribute('content', 'noindex, nofollow');
  }, []);

  return (
    <PageContainer>
      <ConfirmDeletion />
    </PageContainer>
  );
};

export default ConfirmDeletionPage;

